import React, {useCallback, useState} from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {
    useRegionsQueryQuery,
    useRegionsMutationMutation,
    Region,
    RegionsQueryQuery, UpdateRegion
} from '../../generated/graphql';
import {FieldTableColumnProps} from 'components/FieldTable/FieldTableTypes';
import {RegionTypeSelect} from "../../components/MaterialSelects/RegionTypeSelect";
import {Tooltip} from "@mui/material";
import {useLocation} from "react-router";
import {FieldTableTitleTooltip} from "../../components/FieldTable/FieldTableTitleTooltip";
import {uniqueId} from "../../utils";


const columns: FieldTableColumnProps<Region>[] = [{
    header: 'Name',
    accessor: 'name',
    dataType: 'text',
}, {
    header: 'Region Type',
    accessor: 'regionType',
    sort: 'regionType.name',
    dataType: 'select',
    options: {
        label: 'name',
        // eslint-disable-next-line react/display-name
        renderEditor: ({field}) => <RegionTypeSelect {...field}/>
    }
    // eslint-disable-next-line react/prop-types, react/display-name
}, {
    headerRaw: 'Area Booking',
    header: <Tooltip title="Is this shown under area booking?"><FieldTableTitleTooltip>Area Booking</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'is_area_booking',
    dataType: 'boolean',

}, {
    headerRaw: 'Panel Booking',
    header: <Tooltip title="Is this shown under panel booking?"><FieldTableTitleTooltip>Panel Booking</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'is_panel_booking',
    dataType: 'boolean',
}, {
    headerRaw: 'Manual Area Pricing',
    header: <Tooltip title="Area pricing must be entered manually when this is selected"><FieldTableTitleTooltip>Manual Area
        Pricing</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'manual_area_booking_pricing',
    dataType: 'boolean',
}
];

const optionalColumns:FieldTableColumnProps<Region>[] = [
    {
        headerRaw:'Map Code',
        header:<Tooltip title="Code for displaying a map of preview locations on the area bookings page"><FieldTableTitleTooltip>Map Code</FieldTableTitleTooltip></Tooltip>,
        accessor:'example_map_string',
        dataType:'text',
    }
];




function newRow(): Region {
    return {
        id: uniqueId(),
        name: '',
        regionType: null,
        is_area_booking: true
    };
}

const schema = yup.array().of(yup.object().shape({
                'regionType': yup.object().required(),
                'name': yup.string().required()

}));

function getValues(query: RegionsQueryQuery): Region[] {
    // query.data or whatever is stored in the object
    return query?.regions?.data??[];
}

const relationships = {
    'regionType': 'connect'
};

const Regions = () => {
    const url = useLocation().pathname;
    const [shownColumns,setShownColumns] = useState([]);
    const regionsQuery = useRegionsQueryQuery();
    const [mutation, mutationResult] = useRegionsMutationMutation();
    return (
        <ListEditor
            columns={columns}
            validationSchema={schema}
            title="Regions"
            permission="regional"
            query={regionsQuery}
            newRow={newRow}
            newRowLabel="Add Region"
            baseUrl={url}
            shownColumns={shownColumns}
            setShownColumns={setShownColumns}
            optionalColumns={optionalColumns}
            maxOptionalColumns={3}
            getValues={getValues}
            className="regions"
            relationships={relationships}
            saveResult={mutationResult}
            mutation={mutation}
        />);
}

export default Regions;
